import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import { IMAGE_CONSTANT, TOUR_TARGET_ELEMENT } from '../../constants/app';
import LazyImage from '../../ui-core/Image';
import { isLoggedIn } from '../../utils/helpers';
import { APP_ROUTES } from '../../route';
import { fetchCommunityProfileRequest } from '../../store/action/community';
import useProfileAvatar from '../../hooks/useProfileAvatar';

const ProfileImage = ({ className }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const userImage = useProfileAvatar();

  const handleClick = () => navigate(APP_ROUTES.PROFILE);

  const handleError = () => {
    if (isLoggedIn()) {
      dispatch(fetchCommunityProfileRequest());
    }
  };

  return (
    <LazyImage
      className={className}
      dataTourId={TOUR_TARGET_ELEMENT.profile}
      errorSrc={IMAGE_CONSTANT.defaultProfileIcon}
      placeholderSrc={IMAGE_CONSTANT.personIcon}
      onClick={handleClick}
      onError={handleError}
      src={userImage}
    />
  );
};

ProfileImage.propTypes = {
  className: PropTypes.string,
};

export default ProfileImage;
